import { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import Popover from 'beam/dist/Popover'
import List, { ListSubheader, ListItemSecondaryAction, ListItem, ListItemText } from 'beam/dist/List'
import Divider from 'beam/dist/Divider'
import withStyles from 'beam/dist/styles'

const styles = ({ palette }) => ({
  root: {},
  list: {
    borderTop: `3px solid ${palette.secondary.main}`,
    paddingTop: 0,
    paddingBottom: 0,
  },
  listItem: {},
  subheader: {
    backgroundColor: '#ececec !important', // FIXME:
    textTransform: 'uppercase !important',
    lineHeight: '36px !important',
    fontWeight: 'bold',
  },
  footer: {
    paddingTop: '2px',
    paddingBottom: '2px',
    backgroundColor: '#ececec',
    borderTop: '1px solid rgba(0, 0, 0, 0.12)',
  },
})

const DropdownList = withStyles(styles)(({ classes, children, ...props }) => (
  <List className={classes.list} {...props}>
    {children}
  </List>
))

const DropdownListSubheader = withStyles(styles)(({ classes, children, ...props }) => (
  <Fragment>
    <ListSubheader className={classes.subheader} {...props}>
      {children}
    </ListSubheader>
    <Divider />
  </Fragment>
))

const DropdownListItem = withStyles(styles)(({ classes, children, ...props }) => (
  <ListItem className={classes.listItem} {...props}>
    <ListItemText primary={children} />
  </ListItem>
))

const DropdownFooter = withStyles(styles)(({ classes, children, ...props }) => (
  <div className={classes.footer} {...props}>
    {children}
  </div>
))

class Dropdown extends Component {
  static propTypes = {
    anchor: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
    classes: PropTypes.object.isRequired,
  }

  render() {
    const { classes, anchor, open, onClose, children } = this.props

    return (
      <Popover
        open={open}
        onClose={onClose}
        anchorEl={anchor}
        anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
        classes={{ paper: classes.root }}
      >
        {children}
      </Popover>
    )
  }
}

export {
  DropdownList,
  DropdownListSubheader,
  DropdownListItem,
  DropdownFooter,
  ListItemText as DropdownListItemText,
  ListItemSecondaryAction as DropdownListItemSecondaryAction,
}
export default withStyles(styles)(Dropdown)
